import LookUpModel from "./LookUpModel";

export default class SegmentiModel extends LookUpModel {
    constructor(data: Partial<SegmentiModel>) {
        super(data);

        this.update(data);
    }
}
